<template>
  <div>
    <div v-if="block && $i18n.locale">
      <!-- Head text -->
      <div v-if="getLocalizedData('headtext')" class="mb-2">
        <strong v-html="getLocalizedData('headtext')"></strong>
      </div>

      <!-- Main text -->
      <div v-if="getLocalizedData('text')" class="mb-2" style="white-space: break-spaces;" v-html="getLocalizedData('text')"></div>

      <!-- Link -->
      <a 
        v-if="getLocalizedData('url') && getLocalizedData('buttontext')" 
        :href="getLocalizedData('url')" 
        target="_blank" 
        rel="noopener noreferrer"
        class="text-blue-600 underline dark:text-blue-500 hover:no-underline"
      >
        {{ getLocalizedData('buttontext') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  methods: {
    getLocalizedData(field) {
      if (!this.block?.data?.[field] || !this.$i18n?.locale) {
        return null
      }
      
      const fieldData = this.block.data[field]
      if (typeof fieldData === 'object' && fieldData[this.$i18n.locale]) {
        return fieldData[this.$i18n.locale]
      }
      
      // Fallback to the field value directly if it's not a multilingual object
      return fieldData
    }
  }
}
</script> 